<template>
	<div class='story' >
		<Kaart :data="data" />
	</div>
</template>

<script>
import Kaart from './components/kaart';

import './scss/index.scss'

export default {
	name: 'App',
	data: function() {
		return {
			data: this.$store.state.kaart
		}
	},
	mounted: function() {
		
	},
	components: {
		Kaart
	}
}
</script>
